import React, { useContext, useState } from "react";
import CounterMsgContext from "./CounterMsgContext";
import { Subject } from "rxjs";

type ITabPositionContext = {
  currentTabPosition: string | null;
  setCurrentTabPosition: (value: string) => void;
};

const defaultTabPositionContext: ITabPositionContext = {
  currentTabPosition: "",
  setCurrentTabPosition: (value: string) => {
    console.debug("defaultTabPositionContext", "setCurrentTabPosition", value);
    console.error("No TabPositionContext defined");
  }
};

const TabPositionContext = React.createContext<ITabPositionContext>(
  defaultTabPositionContext
);

const onSectionChangeSubject = new Subject();
export const onSectionChangeObservable = onSectionChangeSubject.asObservable();
const TabPositionProvider = (props: any) => {
  const { getCounterInbox } = useContext(CounterMsgContext);
  const [currentTabPosition, _setCurrentTabPosition] = useState<string | null>(
    null
  );

  const setCurrentTabPosition = (pos: string) => {
    if (currentTabPosition === pos) {
      return;
    }
    onSectionChangeSubject.next(pos);
    getCounterInbox();
    _setCurrentTabPosition(pos);
  };

  const value: ITabPositionContext = {
    currentTabPosition,
    setCurrentTabPosition
  };

  return (
    <TabPositionContext.Provider value={value}>
      {props.children}
    </TabPositionContext.Provider>
  );
};

export { TabPositionProvider };
export default TabPositionContext;
